import { z } from 'zod';

// Column state schema - matches AG Grid ColumnState interface
const columnStateSchema = z.object({
  colId: z.string(),
  hide: z.boolean().nullable().optional(),
  width: z.number().optional(),
  flex: z.number().nullable().optional(),
  sort: z.enum(['asc', 'desc']).nullable().optional(),
  sortIndex: z.number().nullable().optional(),
  aggFunc: z.string().nullable().optional(),
  pivot: z.boolean().nullable().optional(),
  pivotIndex: z.number().nullable().optional(),
  pinned: z
    .union([z.literal('left'), z.literal('right'), z.boolean()])
    .nullable()
    .optional(),
  rowGroup: z.boolean().nullable().optional(),
  rowGroupIndex: z.number().nullable().optional()
});

// Grid layout state - contains array of column states
export const gridLayoutStateSchema = z.object({
  columnState: z.array(columnStateSchema)
});

// Backend response for GET /pms/api/layout/{code}
export const layoutDataSchema = z.object({
  Id: z.string(),
  Category: z.string(),
  UserId: z.string(),
  Code: z.string(),
  Data: z.string(), // JSON stringified GridLayoutState
  UpdatedDate: z.string().nullable().optional()
});

// API response wrapper
export const layoutApiResponseSchema = z.object({
  Error: z.boolean().optional(),
  ErrorMessage: z.string().optional(),
  Data: layoutDataSchema.nullable().optional(),
  Errors: z.array(z.unknown()).optional()
});

// Save response - returns just the ID
export const saveLayoutResponseSchema = z.object({
  Error: z.boolean().optional(),
  ErrorMessage: z.string().optional(),
  Data: z
    .object({
      Id: z.string()
    })
    .nullable()
    .optional(),
  Errors: z.array(z.unknown()).optional()
});

// Types
export type ColumnStateData = z.infer<typeof columnStateSchema>;
export type GridLayoutState = z.infer<typeof gridLayoutStateSchema>;
export type LayoutData = z.infer<typeof layoutDataSchema>;
export type LayoutApiResponse = z.infer<typeof layoutApiResponseSchema>;
export type SaveLayoutResponse = z.infer<typeof saveLayoutResponseSchema>;
